module.exports = __webpack_public_path__ + "img/wind-loads-2.1e8924e3.jpg";